import React from "react";
import get from "lodash/get";

import { getPrivateFileLinkRequest } from "../../api/requests";
import { Icon, Tooltip } from "antd";
import classes from "./FileLink.css";

class FileLink extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      privateFileLoading: null,
    };
  }

  openPrivateFileLink = async () => {
    this.setState({ privateFileLoading: true });

    const { data } = await getPrivateFileLinkRequest({
      url: this.props.url,
    });

    const link = document.createElement("a");
    link.href = get(data, "private_url");
    link.target = "_blank";
    link.click();

    this.setState({ privateFileLoading: false });
  };

  render() {
    const { privateFileLoading } = this.state;

    return (
      <Tooltip placement="topLeft" title="View Document">
        {privateFileLoading ? (
          <Icon type="loading" className={classes.icon} />
        ) : (
          <div className={classes.preview} onClick={this.openPrivateFileLink}>
            <Icon
              type="eye"
              theme="filled"
              className={classes.icon}
            />

            <span className={classes.text}>
              {this.props.text}
            </span>
          </div>
        )}
      </Tooltip>
    );
  }
}

export default FileLink;



// WEBPACK FOOTER //
// ./src/components/FileLink/FileLink.js